<!-- <div class="item">
    <img src="../../assets/images/processing.png" class="circular-image" >
    <p class="txt-color">{{message}}</p>
</div> -->
<div class="container-main">
    <div class="item-div">
        <div class="class-div">
            <img src="../../assets/images/processing.png" class="circular-image" >
        </div>
        <p class="txt-color">{{message}}</p>
    </div>
</div>
